const tabButtons = document.querySelectorAll(
	'.block-tab-graphic-tab > .wp-block-button .wp-block-button__link'
);

const tabBlocks = document.querySelectorAll('.block-tab-graphic');

const toggleTab = (e) => {
	e.preventDefault();

	const tabBlock = e.currentTarget.closest('.block-tab-graphic');

	if (tabBlock) {
		const activeTabs = tabBlock.querySelectorAll(
			'.block-tab-graphic-tab > .wp-block-button.active'
		);

		if (activeTabs.length) {
			activeTabs.forEach((activeTab) => {
				if (activeTab !== e.currentTarget.parentElement) {
					activeTab.classList.remove('active');
				}
			});
		}

		e.currentTarget.parentElement.classList.add('active');

		const selectElement = tabBlock.querySelector(
			'.block-tab-graphic__mobile-select'
		);
		const tab = e.currentTarget.closest('.block-tab-graphic-tab');

		if (tab && tab.hasAttribute('data-index') && selectElement) {
			selectElement.value = tab.getAttribute('data-index');
		}
	}
};

// const mobileSelect = (e) => {
// 	const tabBlock = e.currentTarget.closest('.block-tab-graphic');

// 	if (tabBlock) {
// 		const activeTabs = tabBlock.querySelectorAll(
// 			'.block-tab-graphic-tab > .wp-block-button.active'
// 		);
// 		const currentTabButton = tabBlock.querySelector(
// 			'.block-tab-graphic-tab[data-index="' +
// 				e.currentTarget.value +
// 				'"] > .wp-block-button'
// 		);

// 		if (currentTabButton) {
// 			if (activeTabs.length) {
// 				activeTabs.forEach((activeTab) => {
// 					if (activeTab !== e.currentTarget.parentElement) {
// 						activeTab.classList.remove('active');
// 					}
// 				});
// 			}

// 			currentTabButton.classList.add('active');
// 		}
// 	}
// };

if (tabButtons.length) {
	tabButtons.forEach((tabButton) => {
		tabButton.addEventListener('click', toggleTab);
	});
}

if (tabBlocks.length) {
	tabBlocks.forEach((tabBlock) => {
		const tabs = tabBlock.querySelectorAll('.block-tab-graphic-tab');

		if (tabs.length) {
			// const selectElement = tabBlock.querySelector(
			// 	'.block-tab-graphic__mobile-select'
			// );

			// if (!selectElement) {
			// 	return;
			// }

			tabs.forEach((tab, index) => {
				const tabButton = tab.querySelector(
					'.block-tab-graphic-tab > .wp-block-button'
				);

				if (tabButton) {
					const option = document.createElement('option');
					option.value = index;
					option.text = tabButton.textContent;
					tab.setAttribute('data-index', index);
				}

				tabButton.classList.add('initialized');

				if (0 === index) {
					tabButton.classList.add('active');
				}
			});
		}

		const svgElement = tabBlock.querySelector(
			'.block-tab-graphic__large-svg'
		);

		if (!tabs.length || !tabButtons.length || !svgElement) return;

		let currentIndex = 0;
		let currentRotation = 0;
		let autoRotate = true;
		let interval;

		const prevButton = tabBlock.querySelector('.swiper-button-prev');
		const nextButton = tabBlock.querySelector('.swiper-button-next');

		const goToNextTab = () => {
			clearInterval(interval);
			autoRotate = false;

			const nextIndex = (currentIndex + 1) % tabs.length;
			tabs.forEach((tab) => {
				tab.querySelector('.wp-block-button').classList.remove(
					'loading'
				);
			});

			switchToTab(nextIndex, true);
			currentIndex = nextIndex;
		};

		const goToPrevTab = () => {
			clearInterval(interval);
			autoRotate = false;

			const prevIndex = (currentIndex - 1 + tabs.length) % tabs.length;
			tabs.forEach((tab) => {
				tab.querySelector('.wp-block-button').classList.remove(
					'loading'
				);
			});

			switchToTab(prevIndex, true);
			currentIndex = prevIndex;
		};

		if (nextButton) {
			nextButton.addEventListener('click', (e) => {
				e.preventDefault();
				goToNextTab();
			});
		}

		if (prevButton) {
			prevButton.addEventListener('click', (e) => {
				e.preventDefault();
				goToPrevTab();
			});
		}

		const switchToTab = (index, isManual = false) => {
			tabs.forEach((tab, i) => {
				const tabButton = tab.querySelector('.wp-block-button');
				const content = tab.querySelector('.block-content');

				if (i === index) {
					tabButton.classList.add('active');

					// Only add 'loading' if it's an auto-rotation, not a manual click
					if (!isManual) {
						tabButton.classList.add('loading');
					}

					content.style.display = 'flex';
				} else {
					tabButton.classList.remove('active', 'loading');
					content.style.display = 'none';
				}
			});

			rotateSVG(index);
		};

		const rotateSVG = (newIndex) => {
			const difference = newIndex - currentIndex;

			if (difference !== 0) {
				// Always move forward by +120 degrees (even when looping)
				currentRotation += 120;
			}

			const isMobile = window.innerWidth < 768;
			const baseTransform = isMobile
				? 'translateY(0) translateX(-50%)'
				: 'translateY(-50%)';

			// Apply rotation, but never reset to 0 (prevents backward rotation effect)
			svgElement.style.transform = `${baseTransform} rotate(${currentRotation}deg)`;
			svgElement.classList.add('rotate');
		};

		const startAutoRotate = () => {
			interval = setInterval(() => {
				if (!autoRotate) return;

				// Remove 'loading' right before switching
				tabs[currentIndex]
					.querySelector('.wp-block-button')
					.classList.remove('loading');

				// Move to the next tab
				const nextIndex = (currentIndex + 1) % tabs.length;
				switchToTab(nextIndex);
				currentIndex = nextIndex;
			}, 5000);
		};

		tabButtons.forEach((tabButton, index) => {
			tabButton.addEventListener('click', (e) => {
				e.preventDefault();
				clearInterval(interval);
				autoRotate = false;
				tabs.forEach((tab) => {
					tab.querySelector('.wp-block-button').classList.remove(
						'loading'
					);
				});
				switchToTab(index, true);
				currentIndex = index;
			});
		});

		switchToTab(currentIndex);

		startAutoRotate();
	});
}
